module.exports = __webpack_public_path__ + "img/homeBanner2.4bfb7afe.png";